/* Los momentos 3 y 5 de la spec 344: cuánto dura cada uno y qué se ve en cada milisegundo. */
export type Momento = 'ingreso' | 'plan-prueba' | 'plan-convertido';

/** El ingreso dura lo del prototipo 04; lo visible termina unos 150 ms antes. */
export const DURACION_DE_MOMENTO: Record<Momento, number> = {
  ingreso: 2300,
  'plan-prueba': 2200,
  'plan-convertido': 2700,
};

const MARCA_DESDE_MS = 650;
const MARCA_HASTA_MS = 1300;
const ACTIVOS_MS = 900;

export function estadoDeMomento(momento: Momento, t: number) {
  return {
    marca: momento === 'ingreso' && t > MARCA_DESDE_MS && t < MARCA_HASTA_MS,
    activos: momento === 'plan-convertido' && t > ACTIVOS_MS,
    terminada: t >= DURACION_DE_MOMENTO[momento],
  };
}

/** El título del momento 5: se ve en la escena y se anuncia aparte a los lectores de pantalla. */
export const TITULO_DE_PLAN_CONVERTIDO = 'Ya tienes los tres frentes de Prixia.';
